import React from 'react'
import Bestseller from "../../Assetes/Images/bestsellers.png"
import { BASE_URL, IMAGE_URL, priceunit } from '../../Components/client-config';
import useTrackEvent from '../../hooks/useTrackHook';
import mergn from 'mergn-webapp-sdk'
import { useTranslation } from 'react-i18next';
import { formatPrice } from '../../utils/format-price';

function BestSeller(props: any) {
    const [addEvent] = useTrackEvent();
    const { t } = useTranslation();
    
    const recordEvent = (product: any) => {

        const makeItem = {
            name: product.combo_name ? product.combo_name : product.item_name,
            price: product.combo_name ? product.combo_mrp_price : product.item_size[0].mrp,
            category: product?.item_group_id ? product?.item_group_id?.group_name : product.group_id?.group_name,
            url : {
                page: `${BASE_URL}menu#${product.combo_id ? 'combo' : 'item'}/${product.combo_name ? product.combo_name.replace(/\s+/g, '') :  product.item_name.replace(/\s+/g, '')}_${product.combo_id ? product.combo_id : product.menu_item_id }`,
                product: `${IMAGE_URL}${product.combo_name ? product.image_url : product.item_size[0].image_url}`
            }
          }
      
          mergn.recordEvent("Product Click", [
            { eventProperty: 'product-name', value: makeItem.name },
            { eventProperty: 'product-price', value: makeItem.price },
            { eventProperty: 'category-name', value: makeItem.category },
            { eventProperty: 'product-page-url', value: makeItem.url.page },
            { eventProperty: 'product-image-url', value: makeItem.url.product }
          ])
      

    }
    
    return (
      <>
        {props.bestSellers && props.bestSellers.length > 0 ? (
          <div className="container">
            <h2 className="items-title">
              <span> {t("BESTSELLERS")}</span>
            </h2>
            <div className="best-seller mt-4">
              {props.bestSellers && props.bestSellers.length > 0 ? (
                props.bestSellers.map((item: any, index: any) => {
                  return item.menu_item_id && item.menu_item_id > 0 ? (
                    <div
                      key={index}
                      onClick={() => {
                        props.selectedItem(item);
                        addEvent({
                          category: "events",
                          events: `view item ${item.item_name}`,
                        });
                      }}
                      className={`best-seller-img ${
                        !item.is_publish ||
                        item.is_snooze ||
                        item.item_close_flag
                          ? "disableShadow"
                          : ""
                      }`}
                    >
                      <div className="saller-arrow">
                        <i className="ri-arrow-right-line"></i>
                      </div>
                      <div className="kfc-box">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <span className="wdp-ribbon wdp-ribbon-two">
                        <span className="d-flex align-items-end">
                          <h5 className="rs-title mb-0">{priceunit}</h5>
                          <h5 className="mb-0 pkr-title">
                            {formatPrice(item.item_size[0].discount_price
                              ? item.item_size[0].discount_price
                              : item.item_size[0].mrp)}
                          </h5>{" "}
                        </span>
                      </span>
                      <h6>{item.item_name}</h6>
                      {item.item_size && item.item_size.length > 0 && (
                        <img
                          onClick={() => recordEvent(item)}
                          className="bestseller-container"
                          src={`${IMAGE_URL}${item.item_size[0].image_url}`}
                          alt={
                            item.item_size[0].alt_text
                              ? item.item_size[0].alt_text
                              : item?.item_name
                          }
                        />
                      )}
                    </div>
                  ) : (
                    <div
                      key={index}
                      onClick={() => {
                        props.selectedItem(item);
                        addEvent({
                          category: "events",
                          events: `view combo ${item.combo_name}`,
                        });
                      }}
                      className={`best-seller-img ${
                        !item.is_publish ||
                        item.is_snooze ||
                        item.item_close_flag
                          ? "disableShadow"
                          : ""
                      }`}
                    >
                      <div className="saller-arrow">
                        <i className="ri-arrow-right-line"></i>
                      </div>
                      <div className="kfc-box">
                        <span></span>
                        <span></span>
                        <span></span>
                      </div>
                      <span className="wdp-ribbon wdp-ribbon-two">
                        <span className="d-flex align-items-end">
                          <h5 className="rs-title mb-0">{priceunit}</h5>
                          <h5 className="mb-0 pkr-title">
                            {formatPrice(item.discount_price
                              ? item.discount_price
                              : item.combo_mrp_price)}
                          </h5>
                        </span>
                      </span>
                      <h6>{item.combo_name}</h6>
                      {item.image_url && (
                        <img
                          onClick={() => recordEvent(item)}
                          className="bestseller-container"
                          src={`${IMAGE_URL}${item.image_url}`}
                          alt={item.alt_text ? item.alt_text : item?.combo_name}
                        />
                      )}
                    </div>
                  );
                })
              ) : (
                <div />
              )}
            </div>
          </div>
        ) : (
          ""
        )}
      </>
    );
}

export default BestSeller;